import React from 'react';

import {asCoreObject} from 'app-core/framework/CoreObjectIntrospectionUtils';
import CoreObjectStarIconRenderer from 'app-core/platform/starrable/CoreObjectStarIcon';
import {FavoriteTemplateStarIcon} from 'notebook/entry-templates/SelectTemplateCollectionItemTree/FavoriteTemplateStarIcon';
import {
  isSubtemplateNode,
  isTemplateNode,
  SelectTemplateCollectionItem,
} from 'notebook/entry-templates/SelectTemplateCollectionItemTree/types';

const StarIcon = ({
  item,
  isStarred,
}: {
  item: SelectTemplateCollectionItem;
  isStarred: boolean;
}): JSX.Element =>
  isSubtemplateNode(item) ? (
    <CoreObjectStarIconRenderer
      item={asCoreObject(item)}
      isStarred={isSubtemplateNode(item) && Boolean(item.star?.isStarred)}
    />
  ) : isTemplateNode(item) ? (
    <FavoriteTemplateStarIcon key="star" isStarred={isStarred} templateId={item.id} />
  ) : (
    <span />
  );

export default StarIcon;
